import originUrl from './originUrl'

export default (ogImage = '/index.png') => {
  if (ogImage.match(/^http/)) {
    return ogImage
  }

  return `${originUrl()}/og-images${ogImage}`
}
